import { render, staticRenderFns } from "./DangerSign.vue?vue&type=template&id=b05352fa&scoped=true"
import script from "./DangerSign.vue?vue&type=script&lang=js"
export * from "./DangerSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05352fa",
  null
  
)

export default component.exports